module.exports = __webpack_public_path__ + "static/media/empty-state.da00a3ae.png";